import { Trans } from '@bonanza-social/i18n';
import { Box, Text } from '@bonanza-social/moonlight';
import { memo, useMemo } from 'react';
import { StatusHorizontalProgressProps } from './StatusHorizontalProgress/StatusHorizontalProgress.types';

function StatusMemberProgress({
  totalLoyaltyPoints,
}: Pick<StatusHorizontalProgressProps, 'totalLoyaltyPoints'>) {
  const transComponents = useMemo(
    () => ({
      b: <Text variant="body-m-semi" color="darkSurfacePrimary" />,
    }),
    [],
  );

  return (
    <Box>
      <Text variant="body-m" color="darkSurfacePrimary" textAlign="center">
        <Trans
          ns="status"
          i18nKey="memberUnlockDisclaimer"
          components={transComponents}
          values={{ points: totalLoyaltyPoints }}
        />
      </Text>
    </Box>
  );
}

export default memo(StatusMemberProgress);
